// ── 현재 상태 배지(회의중/출장중/외근중/휴가중) 공용 컴포넌트 ─────────────────
// 홈 화면 인사말, 사내 메신저 연락처 목록, 하단 상태표시줄에서 동일한 모양으로 사용한다.
// status가 없으면(정상 근무 중) 아무것도 렌더링하지 않는다.
const STATUS_COLORS = {
  회의중: { bg: '#eff6ff', fg: '#1677ff', border: '#bfdbfe' },
  출장중: { bg: '#fff7ed', fg: '#c2410c', border: '#fed7aa' },
  외근중: { bg: '#f0fdf4', fg: '#15803d', border: '#bbf7d0' },
  휴가중: { bg: '#fdf2f8', fg: '#be185d', border: '#fbcfe8' },
};

export default function StatusBadge({ status, style }) {
  if (!status) return null;
  const c = STATUS_COLORS[status] || { bg: '#f1f5f9', fg: '#475569', border: '#e2e8f0' };
  return (
    <span style={{
      display: 'inline-block', padding: '2px 9px', borderRadius: 20, fontSize: 11, fontWeight: 700,
      background: c.bg, color: c.fg, border: `1px solid ${c.border}`, lineHeight: 1.6, whiteSpace: 'nowrap',
      ...style,
    }}>
      {status}
    </span>
  );
}
